import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "refScroll",
    on: {
      "scroll": _vm.loadMore
    }
  }, [_c('div', {
    ref: "refTitle",
    staticClass: "pageTitle"
  }, [_vm._v(_vm._s(_vm.$t("realTime.title")))]), _c('div', {
    ref: "refFilterBar",
    staticClass: "realtime_Wrapper"
  }, [_c('div', {
    staticClass: "realtime_Filter"
  }, [_c('div', {
    staticClass: "realtime_Multiselect"
  }, [_c('multiselect', {
    ref: "multiselect",
    attrs: {
      "options": _vm.getFactoryInfoNameList,
      "placeholder": "案場名稱",
      "max-height": 600,
      "selectLabel": "",
      "deselectLabel": "remove",
      "preserveSearch": true,
      "closeOnSelect": false,
      "clearOnSelect": false,
      "multiple": true
    },
    on: {
      "search-change": _vm.searchChange,
      "select": _vm.searchSelect,
      "remove": _vm.searchRemove
    },
    model: {
      value: _vm.multiselectValue,
      callback: function callback($$v) {
        _vm.multiselectValue = $$v;
      },
      expression: "multiselectValue"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" 查詢無資料，請重新搜尋 ")])])], 1), _c('div', {
    staticClass: "realtime_DataNum text-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.$t("realTime.dataFound")) + ": " + _vm._s(_vm.filterSearch.length) + " ")]), _c('div', {
    staticClass: "realtime_Status text-nowrap"
  }, [_vm._v(" 異常狀態: "), _c('b-form-select', {
    staticClass: "ml-2 mr-3",
    staticStyle: {
      "width": "138px"
    },
    attrs: {
      "disabled": _vm.alertLevelSelectDisAble
    },
    on: {
      "change": _vm.factoryAlertSearch
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('option', {
          attrs: {
            "disabled": ""
          },
          domProps: {
            "value": null
          }
        }, [_vm._v("請選擇")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedAlert,
      callback: function callback($$v) {
        _vm.selectedAlert = $$v;
      },
      expression: "selectedAlert"
    }
  }, [_vm._l(_vm.alertStatusOptions, function (opt) {
    return _c('option', {
      key: opt.value,
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(" " + _vm._s(opt.text) + " ")]);
  }), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- 取消選取 -")])], 2)], 1), _vm.userDetail.role === 'Whole_Admin' ? _c('div', {
    staticClass: "loadAll_Btn--desktop"
  }, [_c('b-button', {
    staticClass: "loadAll_Btn",
    class: {
      'loadAll_Btn--disabled': _vm.isLoadingData
    },
    attrs: {
      "disabled": _vm.isLoadingData
    },
    on: {
      "click": _vm.getAllData
    }
  }, [_c('i', {
    staticClass: "fas fa-solid fa-spinner"
  }), _vm._v(" 全部載入 ")])], 1) : _vm._e()]), _c('div', {
    staticClass: "realtime_Info"
  }, [_c('ul', [_c('li', [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "d-flex align-items-center",
    attrs: {
      "title": "系統正常營運"
    }
  }, [_c('i', {
    staticClass: "fas fa-check-circle mr-1",
    staticStyle: {
      "font-size": "20px",
      "color": "var(--success)"
    }
  }), _c('div', [_vm._v(" " + _vm._s(_vm.$t("realTime.status.systemNormal")) + " (" + _vm._s(_vm.alarmCount(0)) + ") ")])]), _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "d-flex align-items-center",
    attrs: {
      "title": "停電後 Buffer 回補、斷網後計算回補、特殊計算回補、  三日內無資料"
    }
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": require("../assets/file-error.svg"),
      "alt": "資料缺漏回補圖示",
      "width": "20"
    }
  }), _c('div', [_vm._v(" " + _vm._s(_vm.$t("realTime.status.backfill")) + " (" + _vm._s(_vm.alarmCount(5)) + ") ")])])]), _c('li', [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "d-flex align-items-center",
    attrs: {
      "title": "依通訊裝置異常告警數值定義(不含 Inv 斷訊)"
    }
  }, [_c('i', {
    staticClass: "fas fa-radiation-alt mr-1",
    staticStyle: {
      "font-size": "20px",
      "color": "var(--yellow)"
    }
  }), _c('div', [_vm._v(" " + _vm._s(_vm.$t("realTime.status.partialSystemError")) + " (" + _vm._s(_vm.alarmCount(3)) + ") ")])]), _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "d-flex align-items-center",
    attrs: {
      "title": "Inv 斷訊(null)、Inv 未發電"
    }
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": require("../assets/electrical.svg"),
      "alt": "發電數據異常圖示",
      "width": "20"
    }
  }), _c('div', [_vm._v(" " + _vm._s(_vm.$t("realTime.status.noPowerData")) + " (" + _vm._s(_vm.alarmCount(2)) + ") ")])])]), _c('li', [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "d-flex align-items-center",
    attrs: {
      "title": "案場斷網 30 分鐘內"
    }
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": require("../assets/hourglass.svg"),
      "alt": "系統短暫斷線圖示",
      "width": "20"
    }
  }), _c('div', [_vm._v(" " + _vm._s(_vm.$t("realTime.status.deviceDisconnectedShort")) + " (" + _vm._s(_vm.alarmCount(7)) + ") ")])]), _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "d-flex align-items-center",
    attrs: {
      "title": "案場斷網大於 30 分鐘"
    }
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": require("../assets/smart-plug.svg"),
      "alt": "系統未連線圖示",
      "width": "20"
    }
  }), _c('div', [_vm._v(" " + _vm._s(_vm.$t("realTime.status.deviceDisconnected")) + " (" + _vm._s(_vm.alarmCount(6)) + ") ")])])]), _c('li', [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom.html",
      value: {
        title: '1. Inv 有發電但效率不佳(RA)<br>2. Mppt 不發電或發電不佳<br>3. 保證PR / 保證發電量未達標'
      },
      expression: "{\n              title:\n                '1. Inv 有發電但效率不佳(RA)<br>2. Mppt 不發電或發電不佳<br>3. 保證PR / 保證發電量未達標',\n            }",
      modifiers: {
        "hover": true,
        "bottom": true,
        "html": true
      }
    }],
    staticClass: "d-flex align-items-center"
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": require("../assets/poor-power.svg"),
      "alt": "發電效率不佳圖示",
      "width": "20"
    }
  }), _c('div', [_vm._v(" " + _vm._s(_vm.$t("realTime.status.poorPower")) + " (" + _vm._s(_vm.alarmCount(9)) + ") ")])])])]), _vm.userDetail.role === 'Whole_Admin' ? _c('div', {
    staticClass: "loadAll_Btn--mobile"
  }, [_c('b-button', {
    staticClass: "loadAll_Btn",
    class: {
      'loadAll_Btn--disabled': _vm.isLoadingData
    },
    attrs: {
      "disabled": _vm.isLoadingData
    },
    on: {
      "click": _vm.getAllData
    }
  }, [_c('i', {
    staticClass: "fas fa-solid fa-spinner"
  }), _vm._v(" 全部載入 ")])], 1) : _vm._e(), _vm.hasRoleAdmin ? _c('b-button', {
    staticClass: "error_Btn",
    on: {
      "click": _vm.openAllModal
    }
  }, [_c('i', {
    staticClass: "fa fa-bell",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 告警事件 ")]) : _vm._e()], 1)]), _vm._l(7, function (i) {
    return _c('b-col', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.overlayShow,
        expression: "overlayShow"
      }],
      key: i,
      staticStyle: {
        "padding": "0px",
        "margin": "10px"
      },
      attrs: {
        "cols": "12"
      }
    }, [_c('b-skeleton-wrapper', {
      attrs: {
        "loading": true
      },
      scopedSlots: _vm._u([{
        key: "loading",
        fn: function fn() {
          return [true ? _c('b-skeleton-table', {
            attrs: {
              "rows": 1,
              "columns": 11,
              "table-props": {
                bordered: true,
                striped: true
              }
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), _c('b-alert', {
    staticClass: "text-center font-weight-bold mt-3 mx-3",
    attrs: {
      "show": _vm.filterSearch.length === 0 && !_vm.overlayShow && _vm.selectedAlert === '',
      "variant": "secondary"
    }
  }, [_vm._v(" 沒有資料，請聯絡管理員 ")]), _c('div', {
    ref: "refData"
  }, [_vm._l(_vm.filterSearch, function (i, idx) {
    var _i$PrRaMon, _i$PrRaMon2;
    return _c('div', {
      key: idx,
      staticClass: "newRealTimeStyle",
      attrs: {
        "id": i.factoryId
      }
    }, [!_vm.overlayShow ? _c('table', {
      on: {
        "click": function click($event) {
          return _vm.goToSingleSiteInfo(i.displaySiteName, i.factoryId, i.isDemoSite);
        }
      }
    }, [_c('div', {
      staticClass: "rwdFactoryName"
    }, [_vm._v(" " + _vm._s(i.displaySiteName) + " ")]), _c('tr', [_c('th', {
      staticStyle: {
        "font-size": "22px",
        "width": "15%"
      },
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(" " + _vm._s(i.displaySiteName)), i.isDemoSite && _vm.hasRoleAdmin ? _c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.right",
        value: i.factoryName,
        expression: "i.factoryName",
        modifiers: {
          "right": true
        }
      }],
      staticClass: "ml-2 peekDisplayNameBtn"
    }, [_c('i', {
      staticClass: "fas fa-search"
    })]) : _vm._e()]), _c('th', [_vm._v("設置容量(kWp)")]), _vm._m(0, true), _c('th', [_vm._v("模組溫度(°C)")]), _c('th', [_vm._v("直流功率(kW)")]), _c('th', [_vm._v("交流功率(kW)")]), _c('th', [_vm._v("今日發電量(kWh)")]), _c('th', [_vm._v("INV效率(%)")]), _c('th', [_vm._v("RA(%)")]), _c('th', [_vm._v("今日PR(%)")]), _c('th', [_vm._v("案場狀態")])]), _c('tr', [_c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [i.capacityAll && i.displayAlertLevel !== 6 ? _c('td', {
      attrs: {
        "data-title": "設置容量(kWp)"
      }
    }, [_vm._v(" " + _vm._s(i.capacityAll) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "設置容量(kWp)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "設置容量(kWp)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [i.IRR && i.IRR.length && !i.IRR.includes(null) && i.displayAlertLevel !== 6 ? _c('td', {
      key: i.dataTimeFromNow,
      attrs: {
        "data-title": "日照強度(W/㎡)"
      }
    }, [_vm._v(" " + _vm._s(_vm.dbDataHandle(_vm.handleIRRArray(i.IRR) * 1000, 0)) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "日照強度(W/㎡)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "日照強度(W/㎡)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [i.PVTemp && i.displayAlertLevel !== 6 ? _c('td', {
      key: i.dataTimeFromNow,
      attrs: {
        "data-title": "模組溫度(°C)"
      }
    }, [_vm._v(" " + _vm._s(i.PVTemp) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "模組溫度(°C)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "模組溫度(°C)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [i.dcp && i.dcp.length && i.displayAlertLevel !== 6 ? _c('td', {
      key: i.dataTimeFromNow,
      attrs: {
        "data-title": "直流功率(kW)"
      }
    }, [_vm._v(" " + _vm._s(_vm.sumValue(i.dcp)) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "直流功率(kW)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "直流功率(kW)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [i.acp && i.acp.length && i.displayAlertLevel !== 6 ? _c('td', {
      key: i.dataTimeFromNow,
      attrs: {
        "data-title": "交流功率(kW)"
      }
    }, [_vm._v(" " + _vm._s(_vm.sumValue(i.acp)) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "交流功率(kW)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "交流功率(kW)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [i.E_today && i.E_today.length && i.displayAlertLevel !== 6 ? _c('td', {
      key: i.dataTimeFromNow,
      attrs: {
        "data-title": "今日發電量(kWh)"
      }
    }, [_vm._v(" " + _vm._s(_vm.sumValue(i.E_today)) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "今日發電量(kWh)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "今日發電量(kWh)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [i.acp && i.dcp && i.acp.length && i.dcp.length && i.displayAlertLevel !== 6 ? _c('td', {
      key: i.dataTimeFromNow,
      attrs: {
        "data-title": "INV效率(%)"
      }
    }, [_vm._v(" " + _vm._s(_vm.dbDataHandle(_vm.handleInvSum(i.acp) / _vm.handleInvSum(i.dcp) * 100, 0)) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "INV效率(%)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "INV效率(%)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [i.dcp && i.dcp.length && i.capacity && i.capacity.length && i.IRR && i.IRR.length && i.PrRaMon.RA && i.displayAlertLevel !== 6 ? _c('td', {
      key: i.dataTimeFromNow,
      attrs: {
        "data-title": "RA(%)"
      }
    }, [_vm._v(" " + _vm._s(_vm.handleInHundred(_vm.dbDataHandle(parseFloat(i.dcp.reduce(function (a, b) {
      return a + b;
    }).toPrecision(12) / parseFloat(i.capacityAll.toPrecision(12)) / _vm.handleIRRArray(i.IRR)) * 100, 2))) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "RA(%)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "RA(%)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [typeof i.PrRaMon !== 'string' && (_i$PrRaMon = i.PrRaMon) !== null && _i$PrRaMon !== void 0 && _i$PrRaMon.ACP && (_i$PrRaMon2 = i.PrRaMon) !== null && _i$PrRaMon2 !== void 0 && _i$PrRaMon2.PR && i.capacity && i.capacity.length && i.displayAlertLevel !== 6 ? _c('td', {
      attrs: {
        "data-title": "今日PR(%)"
      }
    }, [_vm._v(" " + _vm._s(_vm.dbDataHandle(i.PrRaMon.PR * 100, 1)) + " ")]) : i.displayAlertLevel === 6 ? _c('td', {
      attrs: {
        "data-title": "今日PR(%)"
      }
    }, [_vm._v(" - ")]) : _c('td', {
      attrs: {
        "data-title": "今日PR(%)"
      }
    }, [_vm._v("null")])]), _c('transition', {
      attrs: {
        "name": "slide-fade"
      }
    }, [_c('td', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.right",
        value: _vm.alertLevelToText(_vm.gateAlertLevel(i.displayAlertLevel)),
        expression: "\n                alertLevelToText(gateAlertLevel(i.displayAlertLevel))\n              ",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "data-title": "案場狀態"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.openSiteModal(i.factoryName, i.displaySiteName, i.isDemoSite, i.factoryId);
        }
      }
    }, [_vm.gateAlertLevel(i.displayAlertLevel) === 0 ? _c('i', {
      staticClass: "fas fa-check-circle",
      staticStyle: {
        "color": "var(--success)"
      }
    }) : _vm.gateAlertLevel(i.displayAlertLevel) === 1 || _vm.gateAlertLevel(i.displayAlertLevel) === 2 ? _c('img', {
      staticClass: "pb-1",
      attrs: {
        "src": require("../assets/electrical.svg"),
        "alt": "發電數據異常圖示",
        "width": "20"
      }
    }) : _vm.gateAlertLevel(i.displayAlertLevel) === 3 ? _c('i', {
      staticClass: "fas fa-radiation-alt",
      staticStyle: {
        "color": "var(--yellow)"
      }
    }) : _vm.gateAlertLevel(i.displayAlertLevel) === 5 ? _c('img', {
      staticClass: "pb-1",
      attrs: {
        "src": require("../assets/file-error.svg"),
        "alt": "資料缺漏回補圖示",
        "width": "20"
      }
    }) : _vm.gateAlertLevel(i.displayAlertLevel) === 6 ? _c('img', {
      staticClass: "pb-1",
      attrs: {
        "src": require("../assets/smart-plug.svg"),
        "alt": "系統未連線圖示",
        "width": "20"
      }
    }) : _vm.gateAlertLevel(i.displayAlertLevel) === 7 ? _c('img', {
      staticClass: "pb-1",
      attrs: {
        "src": require("../assets/hourglass.svg"),
        "alt": "系統短暫斷線圖示",
        "width": "20"
      }
    }) : _vm.gateAlertLevel(i.displayAlertLevel) === 4 ? _c('i', {
      staticClass: "fas fa-search-minus",
      staticStyle: {
        "color": "var(--purple)"
      }
    }) : _vm.gateAlertLevel(i.displayAlertLevel) === 9 ? _c('img', {
      staticClass: "pb-1",
      attrs: {
        "src": require("../assets/poor-power.svg"),
        "alt": "發電效率不佳圖示",
        "width": "20"
      }
    }) : _vm._e()])])], 1)]) : _vm._e()]);
  }), _vm.isLoadingData ? _c('div', {
    staticClass: "text-center m-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "type": "grow"
    }
  }), _vm._v(" Loading... ")], 1)], 1) : _vm._e()], 2), _c('b-modal', {
    attrs: {
      "id": "siteAlertModal",
      "size": "xl",
      "hide-footer": "",
      "hide-header": "",
      "body-class": "p-0"
    }
  }, [_c('div', {
    staticClass: "alarmMH"
  }, [_c('div', {
    staticClass: "alarmMH-left"
  }, [_c('span', {
    staticClass: "alarmMH-dot"
  }), _c('span', {
    staticClass: "alarmMH-name"
  }, [_vm._v(_vm._s(_vm.modalTitle))]), _c('span', {
    staticClass: "alarmMH-sub"
  }, [_vm._v("告警管理")])]), _c('div', {
    staticClass: "alarmMH-right"
  }, [_c('span', {
    staticClass: "alarmMH-label"
  }, [_vm._v("日期")]), _c('date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "value-type": "format",
      "format": "YYYY-MM-DD",
      "type": "date"
    },
    model: {
      value: _vm.alertBeginTime,
      callback: function callback($$v) {
        _vm.alertBeginTime = $$v;
      },
      expression: "alertBeginTime"
    }
  }), _c('span', {
    staticClass: "alarmMH-sep"
  }, [_vm._v("～")]), _c('date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "value-type": "format",
      "format": "YYYY-MM-DD",
      "type": "date"
    },
    model: {
      value: _vm.alertEndTime,
      callback: function callback($$v) {
        _vm.alertEndTime = $$v;
      },
      expression: "alertEndTime"
    }
  }), _c('button', {
    staticClass: "alarmBtn-query",
    on: {
      "click": function click($event) {
        return _vm.queryModal(_vm.modalTitle);
      }
    }
  }, [_vm._v("查詢")]), _c('b-form-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "size": "sm",
      "placeholder": "搜尋變流器／串別…"
    },
    model: {
      value: _vm.alertFilterInput,
      callback: function callback($$v) {
        _vm.alertFilterInput = $$v;
      },
      expression: "alertFilterInput"
    }
  }), !_vm.alertModalNoData ? _c('div', {
    staticClass: "alarmMH-total"
  }, [_c('span', [_vm._v("總告警")]), _c('span', {
    staticClass: "alarmMH-count"
  }, [_vm._v(_vm._s(_vm.visibleAlarmCount))]), _c('span', [_vm._v("筆")])]) : _vm._e(), _c('button', {
    staticClass: "alarmBtn-close",
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('siteAlertModal');
      }
    }
  }, [_vm._v("×")])], 1)]), !_vm.alertModalNoData ? _c('div', {
    staticClass: "alarmFilterStrip"
  }, _vm._l(_vm.levelButtons, function (btn) {
    return _c('button', {
      key: btn.level,
      staticClass: "alarmFP",
      class: {
        'alarmFP--active': _vm.alertFilterLevelNum.includes(btn.level)
      },
      style: {
        '--fp-color': _vm.sevColor(btn.level)
      },
      on: {
        "click": function click($event) {
          return _vm.toggleAlertLevelBtn(btn.level);
        }
      }
    }, [_c('span', {
      staticClass: "alarmFP-badge"
    }, [_vm._v(_vm._s(_vm.levelSum(btn.level)))]), _vm._v(_vm._s(btn.text) + " ")]);
  }), 0) : _vm._e(), _vm.alertTableLoading ? _c('div', {
    staticClass: "text-center my-4 py-3"
  }, [_c('b-spinner', {
    staticClass: "align-middle mr-3"
  }), _c('strong', [_vm._v("讀取中...")])], 1) : !_vm.alertModalNoData ? _c('div', {
    staticClass: "alarmAccordion"
  }, _vm._l(_vm.groupedAlarms, function (g) {
    return _c('div', {
      key: g.key,
      staticClass: "alarmCard",
      style: {
        borderLeftColor: _vm.sevColor(g.severity)
      }
    }, [_c('div', {
      staticClass: "alarmCardHead",
      on: {
        "click": function click($event) {
          return _vm.toggleGroup(g);
        }
      }
    }, [_c('span', {
      staticClass: "alarmInv",
      style: {
        color: _vm.sevColor(g.severity)
      }
    }, [_vm._v(" " + _vm._s(_vm.groupInvLabel(g)) + " ")]), _c('span', {
      staticClass: "alarmSev",
      style: {
        color: _vm.sevColor(g.severity)
      }
    }, [_vm._v(" " + _vm._s(_vm.sevLabel(g.severity)) + " ")]), _c('span', {
      staticClass: "alarmStrings"
    }, [_vm._v(_vm._s(_vm.stringSummary(g)))]), g.ongoing ? _c('span', {
      staticClass: "alarmOngoing"
    }, [_vm._v("進行中")]) : _vm._e(), _c('span', {
      staticClass: "alarmCount"
    }, [_vm._v(_vm._s(g.alarms.length) + " 筆")]), _c('span', {
      staticClass: "alarmTime"
    }, [_vm._v(_vm._s(_vm.shortTime(g.latestTime)))]), _c('span', {
      staticClass: "alarmChevron",
      class: {
        open: _vm.isGroupOpen(g)
      }
    }, [_vm._v("▾")])]), _vm.isGroupOpen(g) ? _c('div', {
      staticClass: "alarmCardBody"
    }, _vm._l(g.alarms, function (a, i) {
      return _c('div', {
        key: i,
        staticClass: "alarmRow",
        style: {
          borderLeftColor: _vm.sevColor(a['等級'])
        }
      }, [_c('span', {
        staticClass: "alarmPv",
        style: {
          color: _vm.sevColor(a['等級'])
        }
      }, [_vm._v(" " + _vm._s(_vm.alarmPvLabel(a)) + " ")]), _c('span', {
        staticClass: "alarmRowSev",
        style: {
          color: _vm.sevColor(a['等級'])
        }
      }, [_vm._v(" " + _vm._s(_vm.sevLabel(a['等級'])) + " ")]), _c('span', {
        staticClass: "alarmIssue"
      }, [_vm._v(_vm._s(_vm.cleanIssue(a, g)))]), _c('span', {
        staticClass: "alarmStart"
      }, [_vm._v(" " + _vm._s(_vm.shortTime(a['告警啟動時間'])) + " "), a.ongoing ? _c('span', {
        staticClass: "alarmOngoing"
      }, [_vm._v("進行中")]) : _vm._e()])]);
    }), 0) : _vm._e()]);
  }), 0) : _vm._e(), _c('b-alert', {
    staticClass: "text-center font-weight-bold mx-3 my-3",
    attrs: {
      "show": _vm.alertModalNoData,
      "variant": "primary"
    }
  }, [_vm._v(" 沒有異常資料，請選擇其他日期 ")])], 1), _c('b-modal', {
    attrs: {
      "id": "allAlertModal",
      "size": "xl",
      "hide-footer": "",
      "hide-header": "",
      "body-class": "p-0"
    }
  }, [_c('div', {
    staticClass: "alarmMH"
  }, [_c('div', {
    staticClass: "alarmMH-left"
  }, [_c('span', {
    staticClass: "alarmMH-dot"
  }), _c('span', {
    staticClass: "alarmMH-name"
  }, [_vm._v("全部案場")]), _c('span', {
    staticClass: "alarmMH-sub"
  }, [_vm._v("告警管理")])]), _c('div', {
    staticClass: "alarmMH-right"
  }, [_c('span', {
    staticClass: "alarmMH-label"
  }, [_vm._v("日期")]), _c('date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "value-type": "format",
      "format": "YYYY-MM-DD",
      "type": "date"
    },
    model: {
      value: _vm.allAlertTime,
      callback: function callback($$v) {
        _vm.allAlertTime = $$v;
      },
      expression: "allAlertTime"
    }
  }), _c('button', {
    staticClass: "alarmBtn-query",
    on: {
      "click": function click($event) {
        return _vm.queryModal('all');
      }
    }
  }, [_vm._v("查詢")]), _c('b-form-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "size": "sm",
      "placeholder": "搜尋案場／變流器…"
    },
    model: {
      value: _vm.alertFilterInput,
      callback: function callback($$v) {
        _vm.alertFilterInput = $$v;
      },
      expression: "alertFilterInput"
    }
  }), !_vm.alertModalNoData ? _c('div', {
    staticClass: "alarmMH-total"
  }, [_c('span', [_vm._v("總告警")]), _c('span', {
    staticClass: "alarmMH-count"
  }, [_vm._v(_vm._s(_vm.visibleAlarmCount))]), _c('span', [_vm._v("筆")])]) : _vm._e(), _c('button', {
    staticClass: "alarmBtn-close",
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('allAlertModal');
      }
    }
  }, [_vm._v("×")])], 1)]), !_vm.alertModalNoData ? _c('div', {
    staticClass: "alarmFilterStrip"
  }, _vm._l(_vm.levelButtons, function (btn) {
    return _c('button', {
      key: btn.level,
      staticClass: "alarmFP",
      class: {
        'alarmFP--active': _vm.alertFilterLevelNum.includes(btn.level)
      },
      style: {
        '--fp-color': _vm.sevColor(btn.level)
      },
      on: {
        "click": function click($event) {
          return _vm.toggleAlertLevelBtn(btn.level);
        }
      }
    }, [_c('span', {
      staticClass: "alarmFP-badge"
    }, [_vm._v(_vm._s(_vm.levelSum(btn.level)))]), _vm._v(_vm._s(btn.text) + " ")]);
  }), 0) : _vm._e(), _vm.alertTableLoading ? _c('div', {
    staticClass: "text-center my-4 py-3"
  }, [_c('b-spinner', {
    staticClass: "align-middle mr-3"
  }), _c('strong', [_vm._v("讀取中...")])], 1) : !_vm.alertModalNoData ? _c('div', {
    staticClass: "alarmAccordion"
  }, _vm._l(_vm.groupedAlarms, function (g) {
    return _c('div', {
      key: g.key,
      staticClass: "alarmCard",
      style: {
        borderLeftColor: _vm.sevColor(g.severity)
      }
    }, [_c('div', {
      staticClass: "alarmCardHead",
      on: {
        "click": function click($event) {
          return _vm.toggleGroup(g);
        }
      }
    }, [_c('span', {
      staticClass: "alarmFactory"
    }, [_vm._v(_vm._s(g.factoryName))]), _c('span', {
      staticClass: "alarmInv",
      style: {
        color: _vm.sevColor(g.severity)
      }
    }, [_vm._v(" " + _vm._s(_vm.groupInvLabel(g)) + " ")]), _c('span', {
      staticClass: "alarmSev",
      style: {
        color: _vm.sevColor(g.severity)
      }
    }, [_vm._v(" " + _vm._s(_vm.sevLabel(g.severity)) + " ")]), _c('span', {
      staticClass: "alarmStrings"
    }, [_vm._v(_vm._s(_vm.stringSummary(g)))]), g.ongoing ? _c('span', {
      staticClass: "alarmOngoing"
    }, [_vm._v("進行中")]) : _vm._e(), _c('span', {
      staticClass: "alarmCount"
    }, [_vm._v(_vm._s(g.alarms.length) + " 筆")]), _c('span', {
      staticClass: "alarmTime"
    }, [_vm._v(_vm._s(_vm.shortTime(g.latestTime)))]), _c('span', {
      staticClass: "alarmChevron",
      class: {
        open: _vm.isGroupOpen(g)
      }
    }, [_vm._v("▾")])]), _vm.isGroupOpen(g) ? _c('div', {
      staticClass: "alarmCardBody"
    }, _vm._l(g.alarms, function (a, i) {
      return _c('div', {
        key: i,
        staticClass: "alarmRow",
        style: {
          borderLeftColor: _vm.sevColor(a['等級'])
        }
      }, [_c('span', {
        staticClass: "alarmPv",
        style: {
          color: _vm.sevColor(a['等級'])
        }
      }, [_vm._v(" " + _vm._s(_vm.alarmPvLabel(a)) + " ")]), _c('span', {
        staticClass: "alarmRowSev",
        style: {
          color: _vm.sevColor(a['等級'])
        }
      }, [_vm._v(" " + _vm._s(_vm.sevLabel(a['等級'])) + " ")]), _c('span', {
        staticClass: "alarmIssue"
      }, [_vm._v(_vm._s(_vm.cleanIssue(a, g)))]), _c('span', {
        staticClass: "alarmStart"
      }, [_vm._v(" " + _vm._s(_vm.shortTime(a['告警啟動時間'])) + " "), a.ongoing ? _c('span', {
        staticClass: "alarmOngoing"
      }, [_vm._v("進行中")]) : _vm._e()])]);
    }), 0) : _vm._e()]);
  }), 0) : _vm._e(), _c('b-alert', {
    staticClass: "text-center font-weight-bold mx-3 my-3",
    attrs: {
      "show": _vm.alertModalNoData,
      "variant": "primary"
    }
  }, [_vm._v(" 沒有異常資料，請選擇其他日期 ")])], 1), !_vm.clientTop ? _c('div', {
    staticClass: "backTop",
    on: {
      "click": _vm.backTop
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-up"
  })]) : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('th', [_vm._v("日照強度"), _c('span', {
    staticClass: "text-nowrap"
  }, [_vm._v("(W/㎡)")])]);
}];
export { render, staticRenderFns };